export const useLogEvent = () => {
  const logEvent = ({
    eventName,
    pageTitle,
    value,
  }: {
    eventName: string;
    pageTitle: string;
    value?: number;
  }) => {
    window.gtag('event', eventName, {
      value,
      page_title: pageTitle,
    });
  };

  return { logEvent };
};
